import { render, staticRenderFns } from "./WorkflowAPITriggerInstructions.vue?vue&type=template&id=fb77c5b6&"
import script from "./WorkflowAPITriggerInstructions.vue?vue&type=script&lang=ts&"
export * from "./WorkflowAPITriggerInstructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports